export default "__VITE_ASSET__HQ3KEQVa__"